import React, { useState } from "react";
import "./Servicios.css";
import serviciosHero from "../assets/gente-negocios-dandose-mano-terminando-reunion_1150-37745.avif";

const servicios = [
  {
    id: "01",
    titulo: "Préstamos Personales",
    icono: "💰",
    descripcion:
      "Obtén el dinero que necesitas de forma rápida y sencilla. Ideal para emergencias, gastos del hogar o cualquier necesidad personal.",
    beneficios: ["Aprobación en 24 horas", "Sin tanto papeleo", "Montos flexibles", "Cuotas cómodas"],
  },
  {
    id: "02",
    titulo: "Préstamos Hipotecarios",
    icono: "🏠",
    descripcion:
      "Haz realidad el sueño de tu hogar propio. Te financiamos con planes ajustados a tu capacidad de pago.",
    beneficios: ["Plazos amplios", "Tasas competitivas", "Asesoría personalizada", "Trámite seguro"],
  },
  {
    id: "03",
    titulo: "Financiamiento de Electrodomésticos",
    icono: "📺",
    descripcion:
      "Equipa tu hogar con los electrodomésticos que necesitas. Neveras, lavadoras, aires acondicionados y más.",
    beneficios: ["Sin inicial requerida", "Cuotas semanales o mensuales", "Aprobación inmediata", "Amplio catálogo"],
  },
  {
    id: "04",
    titulo: "Financiamiento General",
    icono: "🚗",
    descripcion:
      "Financia tu vehículo nuevo o usado con condiciones que se adaptan a ti. Trámite rápido y sin complicaciones.",
    beneficios: ["Vehículos nuevos y usados", "Hasta el 80% del valor", "Plazos flexibles", "Proceso express"],
  },
  {
    id: "05",
    titulo: "Préstamos para Negocios",
    icono: "🤝",
    descripcion:
      "Impulsa tu negocio con el capital que necesitas. Capital de trabajo, expansión o equipamiento.",
    beneficios: ["Montos desde RD$50,000", "Planes a medida", "Gestor dedicado", "Respuesta rápida"],
  },
  {
    id: "06",
    titulo: "Financiamiento de Celulares",
    icono: "📱",
    descripcion:
      "Llévate el teléfono que quieres hoy y págalo en cuotas cómodas. Las mejores marcas al alcance de tu bolsillo.",
    beneficios: ["Todas las marcas", "Cuotas desde RD$500", "Entrega inmediata", "Sin tarjeta de crédito"],
  },
  {
    id: "07",
    titulo: "Préstamos PYME",
    icono: "🏢",
    descripcion:
      "Impulsa tu negocio con financiamiento diseñado para pequeñas y medianas empresas.",
    beneficios: ["Montos adaptados a tu negocio", "Planes a medida", "Gestor dedicado", "Aprobación rápida"],
  },
  {
    id: "08",
    titulo: "Préstamo General",
    icono: "📋",
    descripcion:
      "Accede a financiamiento rápido para cualquier necesidad. Sin importar el destino del dinero, te ofrecemos condiciones flexibles y un proceso sencillo.",
    beneficios: ["Aprobación rápida", "Montos flexibles", "Sin muchos requisitos", "Cuotas a tu medida"],
  },
];

export default function Servicios() {
  const [abierto, setAbierto] = useState(null);
  const toggle = (id) => setAbierto(abierto === id ? null : id);

  // FUNCIÓN PARA ENVIAR AL WHATSAPP CON EL SERVICIO CORRESPONDIENTE
  const handleWhatsApp = (e, tituloServicio) => {
    e.stopPropagation(); // Evita que se cierre/abra la tarjeta al dar clic en el botón
    const telefono = "18297131098";
    const mensaje = `Hola, me interesa solicitar información sobre el servicio: *${tituloServicio}*`;
    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="srv-page">

      {/* HERO */}
      <section className="srv-hero">
        <div className="srv-hero-inner">
          <span className="srv-eyebrow">FINANCIERA JM ODEPEM S.R.L.</span>
          <h1 className="srv-h1">
            Nuestros <span className="srv-acento">Servicios</span>
          </h1>
          <p className="srv-subtitulo">
            Soluciones financieras diseñadas para impulsar tus metas personales y empresariales.
          </p>
        </div>
        <div className="srv-hero-img-wrap">
          <img
            src={serviciosHero}
            alt="Equipo JM ODEPEM cerrando trato"
            className="srv-hero-img"
          />
          <div className="srv-hero-img-overlay"></div>
        </div>
      </section>

      {/* GRID */}
      <section className="srv-grid-section">
        <div className="srv-grid">
          {servicios.map((s) => (
            <div
              key={s.id}
              className={`srv-card ${abierto === s.id ? "srv-card--open" : ""}`}
              onClick={() => toggle(s.id)}
            >
              <div className="srv-card-header">
                <div className="srv-icon-box">{s.icono}</div>
                <span className="srv-num">{s.id}</span>
              </div>

              <h3 className="srv-card-titulo">{s.titulo}</h3>

              <div className={`srv-card-body ${abierto === s.id ? "srv-card-body--open" : ""}`}>
                <p className="srv-card-desc">{s.descripcion}</p>
                <ul className="srv-tags">
                  {s.beneficios.map((b, i) => (
                    <li key={i} className="srv-tag">✓ {b}</li>
                  ))}
                </ul>
                <button 
                  className="srv-btn"
                  onClick={(e) => handleWhatsApp(e, s.titulo)}
                >
                  Solicitar ahora →
                </button>
              </div>

              <span className={`srv-toggle-icon ${abierto === s.id ? "srv-toggle-icon--open" : ""}`}>
                {abierto === s.id ? "−" : "+"}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* BANNER */}
      <section className="srv-banner">
        <div className="srv-banner-inner">
          <div>
            <h2>Préstamos y Financiamientos <span>en 24 Horas</span></h2>
            <p>Nos ajustamos a tu necesidad. Contáctanos hoy mismo.</p>
          </div>
          <div className="srv-banner-btns">
            <a 
              href="https://wa.me/18297131098?text=Hola,%20me%20interesa%20solicitar%20un%20pr%C3%A9stamo." 
              className="srv-banner-btn" 
              target="_blank" 
              rel="noreferrer"
            >
              Solicitar ahora →
            </a>
            <a href="/contacto" className="srv-banner-btn srv-banner-btn--outline">
              Contáctanos
            </a>
          </div>
        </div>
      </section>

    </div>
  );
}